import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const DotCircle = createSvgIcon(
  () => (
    <path d="M24.2188 0C10.8398 0 0 10.9375 0 24.2188C0 37.5977 10.8398 48.4375 24.2188 48.4375C37.5 48.4375 48.4375 37.5977 48.4375 24.2188C48.4375 10.9375 37.5 0 24.2188 0ZM32.0312 24.2188C32.0312 28.6133 28.5156 32.0312 24.2188 32.0312C19.8242 32.0312 16.4062 28.6133 16.4062 24.2188C16.4062 19.9219 19.8242 16.4062 24.2188 16.4062C28.5156 16.4062 32.0312 19.9219 32.0312 24.2188Z" />
  ),
  '0 0 49 49'
);
